import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { User } from '~src/interfaces/user.interface';
import SvgIcon from '~src/shared/SvgIcon';
import { showNotification } from '~src/store/app/actions';
import SecondaryButton from '~src/shared/buttons/basicButtons/SecondaryButton.sc';
import { ButtonSection } from '~src/modules/okrs/manageObjectives/create/addObjectiveEntityForm.sc';
import PrimaryButton from '~src/shared/buttons/basicButtons/PrimaryButton.sc';
import { FormTitle } from '~src/modules/okrs/manageObjectives/shared/labels/labelSelectorForm.sc';

interface Props {
  otp: string;
  user: User;
  onHide: () => void;
}

interface DispatchProps {
  notifyClipboard: (identifiers: string) => void;
}

function isTruthy<T>(x?: T): x is T {
  return Boolean(x);
}

const OtpExplanation = styled.div``;

const OtpLoginDetails = styled.div`
  clear: both;
  margin: 10px 0;
  font-size: larger;
  font-weight: bold;
`;
const OtpLoginPassword = styled(OtpLoginDetails)`
  cursor: copy;
`;
const IconContainer = styled.div`
  float: left;
`;

const OtpCreatedDialogContent: FC<Props & DispatchProps> = props => {
  const identifiers: string[] = [props.user.email, props.user.username].filter(isTruthy);
  const formattedIdentifiers = identifiers.shift() + (identifiers.length ? ` (${identifiers.shift()})` : '');

  const copyOtpToClipboard = () => {
    navigator.clipboard.writeText(props.otp);
    props.notifyClipboard(formattedIdentifiers);
  };
  const copyOtpToClipboardAndClose = () => {
    copyOtpToClipboard();
    props.onHide();
  };

  const { t } = useTranslation();

  return (
    <>
      <FormTitle>
        <span style={{ marginBottom: 30, display: 'block' }} data-translation="x.okr.key.result.add.title">
          {t('x.users.otp_dialog_title')}
        </span>
      </FormTitle>
      <OtpExplanation>
        {t('x.user.otp-created-dialog.explanation', { identifiers: formattedIdentifiers })}
      </OtpExplanation>
      <OtpLoginPassword onClick={copyOtpToClipboard}>
        <IconContainer>
          <SvgIcon name="iconClipBoard" />
        </IconContainer>
        <span>{props.otp}</span>
      </OtpLoginPassword>
      <ButtonSection>
        <SecondaryButton type="button" onClick={props.onHide} data-translation="x.button.cancel">
          {t('x.button.cancel')}
        </SecondaryButton>
        &nbsp;
        <PrimaryButton type="button" onClick={copyOtpToClipboardAndClose} data-translation="x.copy_and_close">
          {t('x.copy_and_close')}
        </PrimaryButton>
      </ButtonSection>
    </>
  );
};

const mapDispatchToProps = (dispatch: any): DispatchProps => ({
  notifyClipboard: (identifiers: string) =>
    dispatch(
      showNotification({
        id: 'x.user.otp-created-dialog.copy',
        txtKey: 'x.user.otp-created-dialog.copy',
        txtProps: { identifiers },
        type: 'info',
      }),
    ),
});

const OtpCreatedDialogContentC = connect(null, mapDispatchToProps)(OtpCreatedDialogContent);

export default OtpCreatedDialogContentC;
